/* MEHERAAN wishlist — saved in the customer's browser (localStorage), no app needed.
   Any element with data-tw-wish="<product-handle>" toggles that product; [data-tw-wish-count] shows the total. */
(function () {
  var KEY = 'meheraan_wishlist';
  function read() { try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} emit(); }
  function has(h) { return read().indexOf(h) !== -1; }
  function add(h) { var a = read(); if (a.indexOf(h) === -1) { a.unshift(h); write(a); } }
  function remove(h) { write(read().filter(function (x) { return x !== h; })); }
  function toggle(h) { if (has(h)) { remove(h); return false; } add(h); return true; }
  function emit() { sync(); document.dispatchEvent(new CustomEvent('tw:wishlist:change', { detail: { handles: read() } })); }

  function sync() {
    var a = read();
    var btns = document.querySelectorAll('[data-tw-wish]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i], on = a.indexOf(b.getAttribute('data-tw-wish')) !== -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var t = b.querySelector('[data-tw-wish-text]');
      if (t) t.textContent = on ? (b.getAttribute('data-on-text') || 'Saved to wishlist') : (b.getAttribute('data-off-text') || 'Add to wishlist');
      if (!t) b.setAttribute('aria-label', (on ? 'Remove from wishlist' : 'Add to wishlist'));
    }
    var counts = document.querySelectorAll('[data-tw-wish-count]');
    for (var j = 0; j < counts.length; j++) { counts[j].textContent = a.length; counts[j].hidden = a.length === 0; }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-tw-wish]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var on = toggle(b.getAttribute('data-tw-wish'));
    b.classList.add('is-pop'); setTimeout(function () { b.classList.remove('is-pop'); }, 350);
    if (on && navigator.vibrate) { try { navigator.vibrate(10); } catch (err) {} }
  }, true);

  // cards injected later (recommendations, quick view, infinite scroll) get their state too
  var raf = 0;
  new MutationObserver(function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; sync(); }); })
    .observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });

  window.TWWishlist = { read: read, has: has, add: add, remove: remove, toggle: toggle, sync: sync };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();
